import { z } from "zod";

export enum LinkedButtonWhenEnum {
    CHECKED = 1,
    UNCHECKED = 2,
}

export const LinkedButtonWhenEnumSchema = z.nativeEnum(LinkedButtonWhenEnum);